import Paper from "@mui/material/Paper";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import { t } from "i18next";
import OutsideLinkIcon from "./Icons/OutsideLinkIcon";
import { ConfigModel, selectConfig } from "../store/features/configSlice";
import { useSelector } from "react-redux";
import Divider from "./Divider";
import { useMediaQuery, useTheme } from "@mui/material";

export default function PrivacyButton() {
  const configState: ConfigModel = useSelector(selectConfig);
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Paper
        elevation={0}
        sx={{
          position: sm ? "relative" : "fixed",
          bottom: 0,
          left: 0,
          right: 0,
        }}
      >
        <Divider />
        <BottomNavigation sx={{ height: "2rem" }} showLabels>
          <BottomNavigationAction
            sx={{ height: "2rem" }}
            label={
              <span>
                <OutsideLinkIcon fontSize="smaller" />
                {t("privacy")}
              </span>
            }
            href={configState.privacyLink || ""}
            target="_blank"
          />
        </BottomNavigation>
      </Paper>
    </>
  );
}
